import { Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { Case } from 'dashboard/models/case';
import RelatedObjectCard from 'dashboard/views/DashboardTransactionsShowView/TransactionDetail/RelatedObjectCard';
import { FontWeight } from 'design-system/variables/text';

const NameAndSticker = styled.div`
  display: flex;
  align-items: center;
  font-weight: ${FontWeight.Bold};

  & > div:first-child {
    margin-right: ${Spacing[2]};
  }
`;

interface RelatedCasesProps {
  cases: Case[];
}

const RelatedCases: VFC<RelatedCasesProps> = ({ cases }) => {
  return (
    <>
      {cases.map(({ id, attributes: { name, state } }, i) => (
        <RelatedObjectCard
          key={i}
          title={
            <NameAndSticker>
              <div>{name}</div>
              <CaseStatusSticker caseState={state} />
            </NameAndSticker>
          }
          subTitle={<Link to={`/dashboard/cases/${id}`}>{id}</Link>}
        />
      ))}
    </>
  );
};

export default RelatedCases;
